export default __webpack_public_path__ + "static/media/cover.7b14ef02.jpg";